import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface SettingsState {
  language: string;
  theme: string; // Nous pouvons aussi persister le thème si nécessaire plus tard
}

const initialState: SettingsState = {
  language: "fr", // Langue par défaut
  theme: "system", // Thème par défaut
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    setTheme: (state, action: PayloadAction<string>) => {
      state.theme = action.payload;
    },
    resetSettings: () => initialState,
  },
});

export const { setLanguage, setTheme, resetSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
